import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'brand' })
export class BrandPipe implements PipeTransform {
    transform(value: string): string {
        if (environment.BRAND == "elba") return value;

        return value.replace(/elba/g,"oxford")
        .replace(/Elba/g,"Oxford")
        .replace(/ELBA/g,"OXFORD");

    }
}
